import { render } from "./AttendeeStats.vue?vue&type=template&id=0e974722"
import script from "./AttendeeStats.vue?vue&type=script&lang=js"
export * from "./AttendeeStats.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaspur/Code/online-alv/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__